module.exports = __webpack_public_path__ + "img/apple-iphone-6.49f203cd.jpg";